import axios from "axios"
import { INSCRIT_T } from "../constant/objectType";

export const getInscrit = (inscrits_id: number) : Promise <INSCRIT_T> => {
    return new Promise((resolve, reject) => {
        axios.postForm(
            `${process.env.REACT_APP_API_URL}/api/inscrit/getInscrit.php`,
            {
                inscrits_id: inscrits_id
            }
        ).then(
            res => {
                const data: INSCRIT_T = res.data.data;

                console.log('====================================');
                console.table(data);
                console.log('====================================');

                resolve(data);
            }
        ).catch(
            err => {
                console.error('====================================');
                console.error(err);
                console.error('====================================');

                reject(err);
            }
        )
    })
}